var _style, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSolaSign = function SvgSolaSign(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svgSolaSign",
    x: "0px",
    y: "0px",
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    style: {
      enableBackground: "new 0 0 18 18"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.svgSolaSign{fill:#F7B100;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path_solaSign",
    className: "svgSolaSign svgBase svgHover svgSelect",
    d: "M9,18c-5,0-9-4-9-9c0-5,4-9,9-9c5,0,9,4,9,9C18,14,14,18,9,18z M5.2,11.2 C5.2,11.2,5.2,11.2,5.2,11.2l0,2.4c0,0,0,0.1,0.1,0.1c0.5,0.2,1.1,0.4,1.6,0.6l1,0.4L8,14.7l1.2,0.5c0.1,0,0.1,0,0.2,0 c0,0,0.1,0,0.1,0l3.9-1.6c0,0,0,0,0,0c0,0,0.1-0.1,0.1-0.1V8.9c0-0.1,0-0.1-0.1-0.1c-0.3-0.1-0.6-0.3-0.9-0.4S11.9,8.1,11.6,8 c-0.3-0.2-0.7-0.3-1.1-0.4S9.8,7.3,9.4,7.1c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0.1v1c0,0.1,0,0.1,0,0.1c0,0-0.1,0-0.1,0L8.6,8 C8.3,7.9,8,7.8,7.7,7.6c0,0-0.1-0.1-0.1-0.1V5.9c0,0,0-0.1,0.1-0.1c0,0,0,0,0,0c0.3-0.1,0.5-0.2,0.8-0.3S9,5.2,9.3,5.1 c0,0,0,0,0.1,0c0,0,0,0,0.1,0c0,0,0,0,0,0c0.4,0.1,0.7,0.3,1,0.4c0.2,0.1,0.5,0.2,0.7,0.3c0.7,0.3,1.5,0.6,2.2,0.8l0,0 c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0-0.1V4.3c0,0,0-0.1-0.1-0.1c-0.3-0.1-0.6-0.2-0.9-0.4s-0.6-0.2-0.9-0.4 c-0.3-0.1-0.7-0.3-1.1-0.4h0C10.1,3,9.7,2.8,9.4,2.7H9.3C8.9,2.8,8.6,3,8.3,3.1C7.6,3.4,7,3.6,6.3,3.9C6.1,4,5.9,4,5.8,4.1 S5.4,4.2,5.3,4.3c0,0-0.1,0.1-0.1,0.1v4.8c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.1,0.1,0.2,0.1C6,9.6,6.4,9.8,6.7,9.9s0.7,0.3,1.1,0.4 l0.9,0.4l0.4,0.1c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0-0.1v-1c0-0.1,0-0.1,0.1-0.1c0,0,0.1,0,0.1,0c0.5,0.2,1,0.4,1.5,0.6l0,0 c0.1,0,0.1,0,0.1,0.1v1.6c0,0.1,0,0.1-0.1,0.1c-0.5,0.2-1,0.4-1.5,0.6l0,0H9.2c-0.1,0-0.2-0.1-0.3-0.1s-0.2-0.1-0.3-0.1 c-0.4-0.2-0.8-0.3-1.3-0.5s-0.8-0.3-1.3-0.5c-0.1,0-0.3-0.1-0.4-0.1S5.4,11.3,5.2,11.2C5.3,11.2,5.2,11.2,5.2,11.2z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSolaSign, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sola_sign.8081b8f5.svg";
export { ForwardRef as ReactComponent };